import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const QuoteService = {
  actions: {
    fetchQuote ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/quote/' + id,
          method: 'GET'
        })
          .then(resp => {
            const quote = resp.data.quote
            commit('api_success')
            resolve(resp)
            return quote
          })
          .catch(err => {
            commit('api_error')
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    fetchAllQuotes ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/quotes',
          method: 'GET'
        })
          .then(resp => {
            const quotes = resp.data.quotes
            commit('api_success')
            resolve(resp)
            return quotes
          })
          .catch(err => {
            commit('api_error')
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    deleteQuote ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/quote/' + id,
          method: 'DELETE'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
            return resp
          })
          .catch(err => {
            commit('api_error')
            dispatch('catchHandler')
            reject(err)
          })
      })
    }
  }
}

export default QuoteService



// WEBPACK FOOTER //
// ./src/services/quoteService.js